import { Navigate } from 'react-router-dom';
import { getAuthToken } from 'src/utils/auth';

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const token = getAuthToken();
    if (!token) return <Navigate to="/" replace />;
    return children;
};
